import { Outlet, Link } from 'react-router-dom';
import AceHorizonLogo from '@/assets/Acehorizon_logo.svg';

export function AuthLayout() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-900 p-4">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <Link to="/" className="inline-block">
            <img 
              src={AceHorizonLogo} 
              alt="Ace Horizon" 
              className="h-12 mx-auto hover:opacity-80 transition-opacity cursor-pointer"
            />
          </Link>
          <p className="text-muted-foreground mt-2">
            AI-powered learning platform
          </p>
        </div>
        <Outlet />
      </div>
    </div>
  );
}
